<template>
  <div id="myfooter">
    <v-footer padless>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong
          >@CYCH 戴德森醫療財團法人嘉義基督教醫院 自殺暨藥酒癮防治中心</strong
        >
        <span v-html="adminlogin"></span>       
      </v-col>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    //  adminlogin:"<a href='http://localhost/CychRwd/2640/login.aspx' class='login'>管理</a>"
    adminlogin:
      "<a href='http://webtest.cych.org.tw/ASPNET/CychRwd/2640/login.aspx' class='login'>管理</a>",
  }),
};
</script>

<style>
#myfooter .theme--light.v-footer {
  background-color: rgb(121, 119, 119);
  color: #fff;
  text-align: center;
  padding: 10px;
}
#myfooter a {
  color: #fff !important;
}
.login {
  color: #fff;
  margin-left: 1rem;
  background: #645a55;
  padding: 4px 12px;
  border-radius: 40px;
}
.login:hover {
  background: #4c4440;
}
</style>
